/*jshint esversion: 6 */
import * as Sentry from "@sentry/browser";
import "flatpickr";
import { German } from "flatpickr/dist/l10n/de";
import { Portuguese } from "flatpickr/dist/l10n/pt";
import { French } from "flatpickr/dist/l10n/fr";
import { Spanish } from "flatpickr/dist/l10n/es";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./assets/scss/main.scss";
import "./assets/sass/main.dashboard.scss";
import { addLocaleData } from "react-intl";
import ReduxWrapper from "./hoc/ReduxWrapper"; // REDUX
import "promise-polyfill/src/polyfill";
import "./polyfills/flatMap";

// define languages you what to use
import en from "react-intl/locale-data/en";
import de from "react-intl/locale-data/de";
import pt from "react-intl/locale-data/pt";
import ru from "react-intl/locale-data/ru";
addLocaleData([...en, ...de, ...ru, ...pt]);

window["flatpickr-de"] = German;
window["flatpickr-pt"] = Portuguese;
window["flatpickr-fr"] = French;
window["flatpickr-es"] = Spanish;

if (process.env.NODE_ENV === "production")
  Sentry.init({
    dsn: "https://glet_1bb11950f84bf7471189ad06aef6cd72@observe.gitlab.com:443/errortracking/api/v1/projects/26596865",
    release: process.env.REACT_APP_SENTRY_RELEASE,
  });

// if our app supports the browser, render it
if (!localStorage.getItem("browserSupport")) {
  const root = React.createElement(ReduxWrapper, {}, React.createElement(App));
  ReactDOM.render(root, document.getElementById("root"));
}
